import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import ReportPage from "@/components/ReportPage";
import PublicShareReport from "@/components/PublicShareReport";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const path = window.location.pathname;
const isReport = path.startsWith("/report/");
const isShare = path.startsWith("/share/");
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      {isShare ? <PublicShareReport /> : isReport ? <ReportPage /> : <App />}
    </QueryClientProvider>
  </React.StrictMode>,
);
